<template>
  <div class="loading-component">
    <!-- Button to trigger the loading animation -->
    <button @click="startLoading" class="action-button">按下開始</button>

    <!-- Button to show the first success message -->
    <button @click="showSuccess" class="action-button">顯示成功畫面</button>

    <!-- Button to show the second success message -->
    <button @click="showPaymentSuccess" class="action-button">顯示繳費成功</button>

    <!-- Button to show the credit card success message -->
    <button @click="showCreditCardSuccess" class="action-button">新增信用卡成功</button>

    <!-- Button to show the submission success message -->
    <button @click="showSubmissionSuccess" class="action-button">送出成功</button>

    <!-- Button to show the application submission success message -->
    <button @click="showApplicationSubmissionSuccess" class="action-button">申辦送出成功</button>

    <!-- Loading animation that appears when `isLoading` is true -->
    <div v-if="isLoading" class="loading-screen">
      <div class="loading-box">
        <div class="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p>帳號登入中...</p>
      </div>
    </div>

    <!-- First success message screen that appears when `isSuccess` is true -->
    <div v-if="isSuccess" class="success-screen">
      <div class="success-box">
        <h2>發送成功</h2>
        <img src="@/assets/icon_success.png" alt="Success" class="success-icon" />
        
        <p>系統已經發送簡訊至您手機<br>請查看後重新設定密碼</p>
        <button @click="closeSuccess" class="success-button">前往登入帳號</button>
      </div>
    </div>

    <!-- Payment success message screen that appears when `isPaymentSuccess` is true -->
    <div v-if="isPaymentSuccess" class="success-screen">
      <div class="success-box">
        <h2>繳費成功</h2>
        <img src="@/assets/icon_success.png" alt="Payment Success" class="success-icon" />
        <p>您本月月票的款項 $3500 元<br>已繳交成功</p>
        <button @click="closePaymentSuccess" class="success-button">回月票繳費頁面</button>
      </div>
    </div>

    <!-- Credit card success message modal that appears when `isCreditCardSuccess` is true -->
    <div v-if="isCreditCardSuccess" class="success-screen">
      <div class="success-box">
        <button @click="goToHomePageFromCreditCard" class="close-button">&times;</button>
        <img src="@/assets/Group 69.png" alt="Credit Card Success" class="credit-card-icon" />
        <h2>新增信用卡成功</h2>
        <p>將重新回到信用卡登記頁面</p>
        <button @click="goToHomePageFromCreditCard" class="success-button">回到首頁</button>
      </div>
    </div>

    <!-- Submission success message screen that appears when `isSubmissionSuccess` is true -->
    <div v-if="isSubmissionSuccess" class="success-screen">
      <div class="success-box">
        <img src="@/assets/icon_success.png" alt="Submission Success" class="success-icon" />
        <h2>送出成功</h2>
        <p>您的委託合作資料已經送出<br>申辦成功時將以電子郵件和電話通知您</p>
        <button @click="closeSubmissionSuccess" class="success-button">回到首頁</button>
      </div>
    </div>

    <!-- Application submission success message screen that appears when `isApplicationSubmissionSuccess` is true -->
    <div v-if="isApplicationSubmissionSuccess" class="success-screen">
      <div class="success-box">
        <img src="@/assets/icon_success.png" alt="Application Submission Success" class="success-icon" />
        <h2>申辦送出成功</h2>
        <p>您的月租申辦資料已經送出<br>申辦成功時將以電子郵件和電話通知您</p>
        <button @click="closeApplicationSubmissionSuccess" class="success-button">回到首頁</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingComponent",
  data() {
    return {
      isLoading: false, // Controls the visibility of the loading animation
      isSuccess: false, // Controls the visibility of the first success message
      isPaymentSuccess: false, // Controls the visibility of the payment success message
      isCreditCardSuccess: false, // Controls the visibility of the credit card success message
      isSubmissionSuccess: false, // Controls the visibility of the submission success message
      isApplicationSubmissionSuccess: false, // Controls the visibility of the application submission success message
    };
  },
  methods: {
    startLoading() {
      this.isLoading = true; // Show loading animation

      // Hide loading animation after 3 seconds
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    },
    showSuccess() {
      this.isSuccess = true; // Show first success message
    },
    closeSuccess() {
      this.isSuccess = false; // Hide first success message
    },
    showPaymentSuccess() {
      this.isPaymentSuccess = true; // Show payment success message
    },
    closePaymentSuccess() {
      this.isPaymentSuccess = false; // Hide payment success message
    },
    showCreditCardSuccess() {
      this.isCreditCardSuccess = true; // Show credit card success message
    },
    goToHomePageFromCreditCard() {
      this.isCreditCardSuccess = false; // Hide credit card success message
      // Add any navigation logic here if needed to redirect to the homepage
      console.log("Redirecting to the homepage...");
    },
    showSubmissionSuccess() {
      this.isSubmissionSuccess = true; // Show submission success message
    },
    closeSubmissionSuccess() {
      this.isSubmissionSuccess = false; // Hide submission success message
    },
    showApplicationSubmissionSuccess() {
      this.isApplicationSubmissionSuccess = true; // Show application submission success message
    },
    closeApplicationSubmissionSuccess() {
      this.isApplicationSubmissionSuccess = false; // Hide application submission success message
    },
  },
};
</script>

<style scoped>
/* Button styling */
.action-button {
  padding: 12px 24px;
  background-color: #008000;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin: 20px;
}

/* Loading screen overlay */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.8); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Loading box */
.loading-box {
  background-color: white;
  padding: 20px 40px;
  border-radius: 10px;
  text-align: center;
}

/* Animated dots */
.dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
}

.dots span {
  width: 12px;
  height: 12px;
  background-color: #008000;
  border-radius: 50%;
  animation: bounce 0.6s infinite alternate;
}

.dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}

/* Loading text */
.loading-box p {
  color: #008000;
  font-size: 1.2rem;
  margin: 0;
}

/* Success screen overlay */
.success-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.8); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Success box styling */
.success-box {
  background-color: white;
  padding: 40px 60px;
  border-radius: 10px;
  text-align: center;
  max-width: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.success-icon, .credit-card-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}

.success-box h2 {
  color: #008000;
  font-size: 2rem;
  margin: 10px 0;
}

.success-box p {
  color: #333;
  font-size: 1rem;
  line-height: 1.5;
}

.success-button {
  padding: 10px 20px;
  background-color: transparent;
  color: #008000;
  font-weight: bold;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 20px;
}

/* Close button for the modal */
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;
}
</style>